let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a1BZ9")).then(() => parcelRequire('fS4PD'));